import { Replay10 } from "@mui/icons-material";

export class SectionProperties {
  constructor({
    // General Properties
    fabrication = 'Hot Rolled',
    availability = 'Common',
    
    // Strength Properties
    fy = 320,  // Normal Strength
    fyw = 320, // Web Normal Strength
    fu = 440,  // Normal Strength
    fyHighStrength = 360,
    fywHighStrength = 360,
    fuHighStrength = 480,
    
    // Shape Details
    d = 0,     // Total Depth
    bf = 0,    // Flange Width
    tf = 0,    // Flange Thickness
    tw = 0,    // Web Thickness
    r1 = 0,     // Root Radius
    
    // Section Properties
    ag = 0,    // Cross-sectional area
    ix = 0,    // Second moment of area about x-axis
    iy = 0,    // Second moment of area about y-axis
    zx = 0,    // Plastic section modulus about x-axis
    zy = 0,    // Plastic section modulus about y-axis
    sx = 0,    // Elastic section modulus about x-axis
    sy = 0,    // Elastic section modulus about y-axis
    rx = 0,    // Radius of gyration about x-axis
    ry = 0,    // Radius of gyration about y-axis
    j = 0,     // Torsion constant
    iw = 0,    // Warping constant
    kf = 0,           // Form Factor
    compactness = '', // Compactness
    
    // Additional Properties
    compactnessX = '', // Compactness about X
    compactnessY = '', // Compactness about Y
    zex = 0,          // Effective Section Modulus X
    zey = 0,          // Effective Section Modulus Y
  } = {}) {
    this.fabrication = fabrication;
    this.availability = availability;
    
    // Strength properties
    this.fy = fy;
    this.fyw = fyw;
    this.fu = fu;
    this.fyHighStrength = fyHighStrength;
    this.fywHighStrength = fywHighStrength;
    this.fuHighStrength = fuHighStrength;
    
    // Shape details
    this.d = d;
    this.bf = bf;
    this.tf = tf;
    this.tw = tw;
    this.r1 = r1;
    
    // Section properties
    this.ag = ag;
    this.ix = ix;
    this.iy = iy;
    this.zx = zx;
    this.zy = zy;
    this.sx = sx;
    this.sy = sy;
    this.rx = rx;
    this.ry = ry;
    this.j = j;
    this.iw = iw;
    this.kf = kf;
    this.compactness = compactness;
    
    // Additional properties
    this.compactnessX = compactnessX;
    this.compactnessY = compactnessY;
    this.zex = zex;
    this.zey = zey;
  }
}

export class Section {
  constructor({
    id,
    name,
    category,
    standard,
    properties,
  }) {
    this.id = id;
    this.name = name;
    this.category = category;
    this.standard = standard;
    this.properties = new SectionProperties(properties);
  }
}
